import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Faz scroll para o topo em cada mudança de rota.
 *
 * - Cobre navegações forward (Link, navigate()).
 * - Cobre back/forward do browser (popstate).
 * - Preserva âncoras de hash (#section) para links internos.
 * - SSR-safe (não toca em window durante render).
 *
 * Deve ser montado dentro do <BrowserRouter> mas acima do <Routes>.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // deixa o browser tratar âncoras internas
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
